import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

import {
    IGst, ITaxRate
} from "../../utils/gst.types";

/**
 * Fetch countries async thunk.
*/
export const fetchGstOptions = createAsyncThunk(
    'gst/fetchGsts',
    async (): Promise<IGst[]> => {
        const response = await axios.get(`/api/v1/gst`);
        return response.data.gsts;
    }
);

export const fetchTaxRates = createAsyncThunk(
    'gst/fetchTaxRates',
    async (): Promise<ITaxRate[]> => {
        const response = await axios.get(`/api/v1/gst/tax-rates`);
    return response.data.taxRates;
    }
);